import React from 'react';
import { useQueryClient } from 'react-query';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Icon } from '../../../../../CommonComponents/OPL/Icon/Icon';
import { ModalBody } from '../../../../../CommonComponents/OPL/Modal/ModalBody';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { ModalFooter } from '../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { useOrganizeItemsContext } from '../../context/useOrganizeItemsContext';
import { queryKeys } from '../../../../api/queryKeys';
import { useRouteParams } from '../../../../hooks/useRouteParams';

export const Complete = () => {
  const { onClose: baseOnClose, sourcePath } = useOrganizeItemsContext();

  const queryClient = useQueryClient();
  const { clientId } = useRouteParams();

  const onClose = () => {
    queryClient.refetchQueries(queryKeys.listDocumentVaultEntities(clientId));

    baseOnClose();
  };

  return (
    <>
      <ModalBody>
        <Box
          py={100}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <Icon className="far fa-check-circle" fontSize="xl" color="primary.500" />

          <Text fontSize="h5" fontWeight={600} mt="24" textAlign="center">
            {sourcePath.length === 1
              ? 'Your item has been successfully moved!'
              : 'Your items have been successfully moved!'}
          </Text>
        </Box>
      </ModalBody>

      <ModalFooter>
        <Button onClick={onClose}>Done</Button>
      </ModalFooter>
    </>
  );
};
